<template>
  <section class="newsletter px-4 py-sm-5 py-4 text-color-black text-center">
    <h4 class="weight-bold mb-4">خبرنامه اینفینیتی</h4>
    <p class="fontsize-medium weight-bold text-center mb-4 line-height2">جهت عضویت در خبرنامه ایمیل خود را وارد کنید!</p>
    <form   @submit.prevent="send()" class="newsletter-form d-flex flex-column">
      <input         v-model="email" class="bg-color-themeOp text-white py-2 rounded-pill fontsize-small text-center mx-auto mb-3" type="email" placeholder="ایمیل خود را وارد کنید...">
      <input class="py-2 bg-color-theme2 text-color-black border-radius10 fontsize-medium mx-auto mb-3" type="submit" value="عضویت در خبرنامه">
    </form>
    <span class="weight-bold fontsize-mini">خیالتان از دریافت ایمیل راحت باشه</span>
  </section>

</template>

<script>
export default {
  name: "NewsLetter",
  data(){
return{
  email:null,
}
  },
  methods:{
      send() {
      if (!this.validateEmail(this.email)) {
        const options = { title: "توجه", size: "sm" };
        this.$dialogs.alert(
          "برای عضویت در خبرنامه ایمیل را به درستی وارد کنید",
          options
        );
      } else {
        const fromData = new FormData();
        fromData.append("email", this.email);
        this.$axios.post("subscribe", fromData).then((res) => {
          const options = { title: "سپاس از شما", size: "sm" };
          this.$dialogs.alert(res.data.message, options);
          this.email = "";
        });
      }
    },
    
    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    }
  }
}
</script>

<style scoped>
.newsletter{
  border-radius: 30px;
  background: #ffffffcc;
}
.newsletter-form input[type='email']{
  width: 80%;
}
.newsletter-form input[type='email']::placeholder{
  font-size: 16px;
  font-family: font-bold;
  opacity: 90%;
}
.newsletter-form input[type='submit'] {
  width: 50%;
}
.newsletter span{
  opacity: 0.9;
}
@media screen and (max-width: 350px){
  .newsletter-form input[type="submit"]{
    width: 70%;
  }
}
</style>